import { Grid, styled, Switch, SwitchProps, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useAccountNotificationSetting } from '../hooks/useAccountNotificationSetting';

export const NotificationSetting = () => {
  const { state, eventHandler } = useAccountNotificationSetting();
  const {
    announcementNotificationEnabled,
    careTeamNotificationEnabled,
    communityNotificationEnabled,
    articleNotificationEnabled,
    eventNotificationEnabled,
  } = state;

  const {
    handleToggleAnnouncementNotification,
    handleToggleCareTeamNotification,
    handleToggleCommunityNotification,
    handleToggleArticleNotification,
    handleToggleEventNotification,
  } = eventHandler;

  return (
    <Grid container sx={{ gap: 10 }}>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage id='account.setting.notify.announcement' />
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <IOSSwitchButton
          checked={announcementNotificationEnabled}
          onChange={handleToggleAnnouncementNotification}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage id='account.setting.notify.care-team-message' />
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <IOSSwitchButton
          checked={careTeamNotificationEnabled}
          onChange={handleToggleCareTeamNotification}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage id='account.setting.notify.community-message' />
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <IOSSwitchButton
          checked={communityNotificationEnabled}
          onChange={handleToggleCommunityNotification}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage id='account.setting.notify.article' />
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <IOSSwitchButton
          checked={articleNotificationEnabled}
          onChange={handleToggleArticleNotification}
        />
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage id='account.setting.notify.event' />
        </Typography>
      </Grid>
      <Grid item xs={7}>
        <IOSSwitchButton
          checked={eventNotificationEnabled}
          onChange={handleToggleEventNotification}
        />
      </Grid>
    </Grid>
  );
};

const IOSSwitchButton = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(23px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
